import React from 'react';

import { useConsoleSidebarSections } from '@/console/features/console-sidebar/hooks/use-console-sidebar-sections/use-console-sidebar-sections';
import { SupportPages } from '@/console/features/support-pages/support-pages';
import { SwitchCompany } from '@/console/features/switch-company/switch-company';
import { Sidebar } from '@/shared/features/sidebar/sidebar';

export const ConsoleSidebar = () => {
  const sections = useConsoleSidebarSections();

  return (
    <Sidebar
      sections={sections}
      bottomContent={(open) => (
        <>
          <SwitchCompany expanded={open} />
          <SupportPages open={open} />
        </>
      )}
    />
  );
};
